import React from 'react'
import Menu1 from '../menu1/menu1'
import './layout.css'

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="layout">
      <Menu1 />
      <main className="layout-content">
        {children}
      </main>
    </div>
  )
}

export default Layout


